import QualityList from './quality-list.js';

/**
 * @extends QualityList
 */
class NativeQualityList extends QualityList {
	constructor(options) {
		super(options);
	}

	addQuality(quality) {
		this.list.push(quality);
		this._sort();
		this.trigger('change');
	}
}

export default NativeQualityList;